import React, { useState, useEffect, useRef } from 'react';
import clsx from 'clsx';
import {
  Box, Button, IconButton,
  InputAdornment, FormControl, CssBaseline, CircularProgress, Grid, TextField,
  OutlinedInput, InputLabel, Typography, Checkbox, FormGroup, Tooltip, ClickAwayListener
} from '@material-ui/core';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import CustomBreadcrum from '../Breadcrum';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Cookies from 'js-cookie';

import { useStyles } from './styles';
import { verifyQuickPayAccount, validateQuickPayOTP, resendCode, deleteAccessTokenQuickPay, quickPayFeedbackDisplay } from '../../actions';
import { getPublicIp, getAppSource, getUserType, renderDefaultMsg, getLoanLabel, getBorrowerLabel, checkDigitOnly, maskAccountNo, maskEmail, scrollTop, maskLoan } from '../../helpers';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import { decrypt, encrypt } from '../../helpers/encrypt';
import { Payment } from './Payment';
import { TransferAlert } from '../TransferAlert';
import { Popover } from 'antd';
import { ALREADY_REGISTERED, SESSION_EXPIRE, PAYMENT_CONFIRMATION_EMAIL } from '../../helpers/constants';
import { AccountRequired } from './SharedComponent/AccountRequired';
import { withStyles } from '@material-ui/core/styles';

import InfoIcon from '@material-ui/icons/Info';
import ReactToPrint from 'react-to-print';
import RefreshIcon from '@material-ui/icons/Refresh';
import VolumeUpIcon from '@material-ui/icons/VolumeUp';
import VolumeOffIcon from '@material-ui/icons/VolumeOff';
import PrintIcon from '@material-ui/icons/Print';

import macbook from '../../assets/QuickPay/macbook.svg';
import checkmark from '../../assets/checkmark.png';
import benefits from '../../assets/QuickPay/benefits.png';
import camera from '../../assets/QuickPay/camera.svg';
import lock from '../../assets/QuickPay/lock.svg';
import symbols from '../../assets/QuickPay/symbols.svg';
import congrats from '../../assets/QuickPay/congrats.svg';
import sessionTimeOut from '../../assets/QuickPay/sessionTimeOut.svg';
import './styles.css';


const LightToolTip = withStyles((theme) => ({
  arrow: {
    color: '#235A86'
  },
  tooltip: {
    backgroundColor: '#235A86',
    color: '#fffff',
    fontFamily: "Montserrat",
    boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.15)',
    padding: "16px",
    fontSize: 14,
    maxWidth: 400,
    fontWeight: 500,
    borderRadius: 8
  },
}))(Tooltip);

export const QuickPay = (props) => {

  const classes = useStyles();
  const history = useHistory();
  const theme = useTheme();
  
  const captchaTimer = useRef(null);
  const increment = useRef(null);
  const componentRef = useRef();
  const mediaQuery = useMediaQuery(theme.breakpoints.down('sm'));

  const [activeTab, setActiveTab] = useState(!true)
  const [loading, setLoading] = useState(false)
  const [errorMsg, setErrorMsg] = useState('')
  const [captchaCode, setCaptchaCode] = useState('')
  const [captchaErr, setcaptchaErr] = useState(false);
  const [volumeIcon, setvolumeIcon] = useState(false);
  const [radioValue, setRadioValue] = useState(true);
  const [values, setValues] = useState({
    showPassword: false,
    borrowerSSN: '',
    foreignId: '',
    loanNumber: '',
    captcha: ''
  });
  const [userDetails, setUserDetails] = useState({
    accountNumber: '',
    borrowerSSN: '',
    loanNumber: '',
    emailID: '',
    pBorrowerName: '',
    propertyAddress: '',
    token: '',
    mlw: '',
    propertyState: '',
    agencyFlag: '',
    bsI0_29Agency: '',
    bsI0_29NonAgency: '',
    bsI30_59Agency: '',
    bsI30_59NonAgency: '',
    bsI60_Agency: '',
    bsI60_NonAgency: ''
  });
  const [purgedLoanInfo, setPurgedLoanInfo] = useState()
  const [otp, setOtp] = useState();
  const [open, setOpen] = useState(false);
  const [checkboxState, setCheckboxState] = useState(false);
  const [maxLimitReach, setMaxLimitReach] = useState(false);
  const [otpLimitExceed, setOtpLimitExceed] = useState(false);
  const [invalidCode, setInvalidCodeStatus] = useState(false);
  const [wrongAttempts, setWrongAttempts] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [leftTime, setLeftTime] = useState(0);
  const [tokenExpireTime, setTokenExpireTime] = useState(null);
  const [paymentDetails, setPaymentDetails] = useState();
  const [submitStatus, setSubmitStatus] = useState(false);
  const [purgedMsg, setPurgedMsg] = useState('');
  const [transferPopup, showTransferPopup] = useState(false);
  const [transferData, setTransferData] = useState({
    fromPrivateLabel: "", toPrivateLabelPhone: "",
    toPrivateLabelURL: "", toPrivateLabel: ""
  });
  const [accountRequiredPopup, setAccountRequired] = useState(false);
  const [emailTooltip, setEmailIdTooltip] = useState(false);

  useEffect(() => {
    createCaptcha()
    handleTimer();
    return () => clearInterval(captchaTimer.current);
  }, [currentStep]);

  const handleTimer = () => {
    captchaTimer.current = setInterval(() => {
      createCaptcha()
    }, 180000);
    return () => clearInterval(captchaTimer.current);
  }

  const handleReset = () => {
    clearInterval(captchaTimer.current);
  }

  const createCaptcha = () => {
    setcaptchaErr(false)
    if (document.getElementById('captcha') !== null) {
      const cpatchCode = returnMathsCaptchaCode();
      setCaptchaCode(cpatchCode)
    }
  }

  const returnMathsCaptchaCode = () => {
    var code;
    document.getElementById('captcha').innerHTML = "";
   
    var captcha = [];
    var canv = document.createElement("canvas");
  
    var fir = Math.floor(Math.random() * 10)
    var third = Math.floor(Math.random() * 10)
    captcha[0] = fir;
    captcha[1] = '+';
    captcha[2] = third;
    captcha[3] = '=';

    canv.id = "captcha";
    canv.width = 170;
    canv.height = 40;
    canv.padding = 10;
    var ctx = canv.getContext("2d");
    ctx.font = "600 36px 'Montserrat'";
    ctx.fillText(captcha.join(""), 0, 30);
    code = captcha.join("");
    document.getElementById("captcha").appendChild(canv);
    return code;
  }

  const check = () => {
    setvolumeIcon(true)
    setTimeout(function () { setvolumeIcon(false) }, 2000);
  }

  const speakk = () => {
    let speech = new SpeechSynthesisUtterance();
    speech.lang = "en-UK";
    speech.text =  captchaCode;
    speech.volume = 2;
    speech.rate = 0.25;
    speech.pitch = 1.4;
    window.speechSynthesis.speak(speech);
  }

  const handleChange = (prop) => (event) => {
    if (prop === 'loanNumber') {
      if ((/^[0-9]+$/).test(event.target.value) || event.target.value === '') {
        setValues({ ...values, [prop]: event.target.value.slice(0, 10) });
      }
      return;
    } else if (prop === 'borrowerSSN') {
      if (activeTab) {
        if (!(/[^\w\s]/gi).test(event.target.value) && !(/\s/g).test(event.target.value)) {
          setValues({ ...values, [prop]: event.target.value.slice(0, 4) });
        }
      } else {
        if (!(/[^\w\s]/gi).test(event.target.value) && !(/\s/g).test(event.target.value)) {
          setValues({ ...values, [prop]: event.target.value.slice(0, 35) });
        }
      }
      return;
    } else if (prop === 'foreignID') {
      if (activeTab) {
        if (!(/[^\w!@#$%^&*()-_+-/*=`~\s]/gi).test(event.target.value) && !(/\s/g).test(event.target.value)) {
          setValues({ ...values, [prop]: event.target.value.slice(0, 4) });
        }
      } else {
        if (!(/[^\w!@#$%^&*()-_+-/*=`~\s]/gi).test(event.target.value) && !(/\s/g).test(event.target.value)) {
          setValues({ ...values, [prop]: event.target.value.slice(0, 35) });
        }
      }
      return;
    }

    setValues({ ...values, [prop]: event.target.value });
    return;
  };

  const handleRadioChange = (event) => {
    setRadioValue(event.target.value);
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

   useEffect(() => {
      let usernames = Cookies.get('loanNos')
      if (usernames != undefined) {
        let parseUserNames = JSON.parse(usernames)
        if (parseUserNames?.length > 0) {
        let userNames = parseUserNames?.filter(key => key.privateLabelName?.toLowerCase() == Cookies.get('privateLabelUrl')?.toLowerCase())
        if (userNames?.length > 0) {
            setValues({
             ...values,
              loanNumber: userNames[0].username
            })
            setCheckboxState(true)
          }
        }
      }
    },[Cookies.get('loanNos')])

  const handleSubmit = async () => {
    if ((Number(captchaCode[0]) + Number(captchaCode[2])) == Number(values.captcha)) {
      setLoading(true);
      setcaptchaErr(false);
      setOtpLimitExceed(false)
      setInvalidCodeStatus(false)

      const data = {
        "accountNumber": encrypt(values.loanNumber),
        "borrowerSSN": radioValue ? encrypt(values.borrowerSSN) : encrypt(values.foreignId),
        "propertyZipCode": '',
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": await getPublicIp(),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "userName": ""
      }
      const res = await verifyQuickPayAccount(data);
      if (res.lstResponseStatus[0].statusCode == 0) {
        setSubmitStatus(true)
        setLoading(false);
        setErrorMsg('')
        setValues({ ...values, borrowerSSN: '', foreignId: '', loanNumber: '', captcha: '' });
        setPurgedLoanInfo(res.purgeLoanInfo)
        setTransferData(res)
       
        if (res.purgeLoanInfo.isLoanPurged) {
          setPurgedMsg('You are trying to access an account that is no longer available since it has been closed for more than 7 years.')
        }

        if (res.emailID) {
          // setOtp();
          // handleOtpTimer();
          // setCurrentStep(2);
          setUserDetails({
            accountNumber: res.accountNumber,
            borrowerSSN: res.borrowerSSN,
            loanNumber: res.accountNumber,
            emailID: res.emailID,
            pBorrowerName: res.pBorrowerName,
            propertyAddress: res.propertyAddress,
            token: res.token,
            mlw: res.hasMLWAccount,
            propertyState: res.propertyState,
            agencyFlag: res.agencyFlag,
            bsI0_29Agency: res.bsI0_29Agency,
            bsI0_29NonAgency: res.bsI0_29NonAgency,
            bsI30_59Agency: res.bsI30_59Agency,
            bsI30_59NonAgency: res.bsI30_59NonAgency,
            bsI60_Agency: res.bsI60_Agency,
            bsI60_NonAgency: res.bsI60_NonAgency,
            transfer: res?.isTransfer
          });
          // setUserDetails({...userDetails, token: token, accessTokenID: accessTokenID})
          setTokenExpireTime("00:00")
          handleTokenExpireTimer(res.token)
          Cookies.set("selectedAccount", res.accountNumber)
          setCurrentStep(3)
          scrollTop()
        }
       
        if (checkboxState && res.emailID) {
          let name = Cookies.get('loanNos')
          if (name != undefined) {
            let savedUsernames = [];
            savedUsernames = JSON.parse(name)
            var index = savedUsernames.findIndex((item) => item.privateLabelName?.toLowerCase() == Cookies.get('privateLabelUrl')?.toLowerCase())
            if (index == -1) {
              savedUsernames.push({'privateLabelName' : Cookies.get("privateLabelUrl")?.toLowerCase(), 'username': values.loanNumber})
              Cookies.set("loanNos", savedUsernames)
            }
              else {
              savedUsernames[index]['username'] = values.loanNumber;
              Cookies.set("loanNos", savedUsernames)
            }
          } else {
            const userNameArr = [];
            userNameArr?.push({privateLabelName : Cookies.get("privateLabelUrl")?.toLowerCase(), username: values.loanNumber}) 
            Cookies.set("loanNos", userNameArr)
          }
        } else {
          let username = Cookies.get('loanNos')
          if (username != undefined) {
            let arr = JSON.parse(username)
            var index = arr.findIndex((item) => item.privateLabelName?.toLowerCase() == Cookies.get('privateLabelUrl')?.toLowerCase())
              if (index !== -1) {
                arr.splice(index,1)
                Cookies.set("loanNos", arr)
              }
          }
        }  
      } else if (res.lstResponseStatus[0].statusDesc.includes('information provided is not valid')) {
        setLoading(false);
        setErrorMsg(res.lstResponseStatus[0].statusDesc)
        setValues({ ...values, captcha: '' });
        setPurgedLoanInfo();
        handleReset();
        handleTimer();
      } else if (res.lstResponseStatus[0].statusDesc.toLowerCase().includes('otp limit')) {
        setLoading(false);
        setOtpLimitExceed(true)
        setValues({ ...values, captcha: '' });
        setPurgedLoanInfo();
        handleReset();
        handleTimer();
      } else if (res.lstResponseStatus[0].statusDesc.toLowerCase().includes('wrong private label client')) {
        setLoading(false);
        setErrorMsg(res.lstResponseStatus[0].statusDesc)
        setValues({ ...values, captcha: '' });
        setPurgedLoanInfo();
        handleReset();
        handleTimer();
      } else {
        setLoading(false);
        setErrorMsg(renderDefaultMsg('400'))
        setValues({ ...values, captcha: '' });
        setPurgedLoanInfo();
        handleReset();
        handleTimer();
      }
    } else {
      createCaptcha();
      setcaptchaErr(true);
      setValues({ ...values, captcha: '' });
      setPurgedLoanInfo();
    }
  }
 
  const hide = () => {
    setOpen(false);
  };

  const handleOpenChange = (newOpen) => {
    if (!checkboxState && (values.loanNumber.length !== 0)) {
      setOpen(newOpen);
    } else {
      setOpen(false)
    }
  };

  const checkboxChangeHandler = () => {
    saveUserName()
  }

  const saveUserName = () => {
    if (values.loanNumber.length === 0) {
      setCheckboxState(false)
    } else {
      setCheckboxState(!checkboxState)
    }
  }

  const handleOtpChange = (prop) => (event) => { 
    if (prop === 'otp') {
      setErrorMsg('');
      setInvalidCodeStatus(false)
      if (checkDigitOnly(event.target.value?.trim())) {
        setOtp(event.target.value );
      }
    }
  }
  
  const handleOtpTimer = () => {
    let timer = 120
    increment.current = setInterval(() => {
      if (timer === 0) {
        setLeftTime("00:00")
        clearInterval(increment.current)
      } else {
        setLeftTime(timer--)
      }
    }, 1000);
    return () => clearInterval(increment.current);
  }

  const showTimer = (rt) => {
    if (rt === 'Completed') {
      return rt
    }
    rt = parseInt(rt)
    let minutes = Math.floor(rt / 60);
    let seconds = rt % 60

    if (seconds < 10) {
      seconds = `0${seconds}`;
    }
    return `0${minutes}:${seconds}`;
  }

  const deleteAccessTokenQP = async (token) => {
    const data = {
      "accessTokenID": userDetails.accessTokenID,
      "privateLabelUrl": Cookies.get("privateLabelUrl"),
      "ipAddress": Cookies.get("publicIp"),
      "browser": Cookies.get("browser"),
      "appSource": getAppSource(),
      "userType": getUserType(),
      "userName":  ""
    }

    const response = await deleteAccessTokenQuickPay(data, token)
    setCurrentStep(0);
  } 

  const stopTokenExpireTimer = () => {
    if (increment.current) {
      clearInterval(increment.current);
      increment.current = null;
    }
  };

  const apiCalled = useRef(false);
  const handleTokenExpireTimer = (token) => {
    // clear any old timer before starting a new one
    if (increment.current) clearInterval(increment.current);
    apiCalled.current = false;

    let duration = 900; // 15 minutes
    setTokenExpireTime(duration);
   
    increment.current = setInterval(() => {
      setTokenExpireTime((prev) => {
        if (prev <= 1) {
          clearInterval(increment.current);
          if (!apiCalled.current) {
            apiCalled.current = true;
            deleteAccessTokenQP(token);
          }
        
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const showTokenExpireTimer = (rt) => {
    if (rt === null) return "--:--"; // not started
    if (rt === 0) return "00:00";
   
    let minutes = Math.floor(rt / 60);
    let seconds = rt % 60;
   
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

   // validate otp
     const validateOtpCode = async () => {
      setLoading(true);
      const data = {
        "otp": encrypt(otp),
        "otpType": "OTPQuickPay",
        "mediumType": "Email",
        "mobileNumber": "",
        "email": userDetails.emailID,
        "accountNumber": userDetails.accountNumber,
        "firstName": encrypt(userDetails.pBorrowerName),
        "privateLabelUrl": Cookies.get("privateLabelUrl"),
        "ipAddress": Cookies.get("publicIp"),
        "browser": Cookies.get("browser"),
        "appSource": getAppSource(),
        "userType": getUserType(),
        "userName":  ""
      }
  
      const response = await validateQuickPayOTP(data)
      setWrongAttempts(false)
  
      if (response?.responseData?.lstResponseStatus[0].statusCode == 0) {
        setLoading(false);
        showTransferPopup(false)
        const { lstResponseStatus } = response?.responseData;
        if ((lstResponseStatus[0].statusCode == 0) && response?.responseData?.responseData.token && !userDetails.tranfer) {
          const token = response?.responseData?.responseData.token;
          const accessTokenID = response?.responseData?.responseData.accessTokenID;
          setUserDetails({...userDetails, token: token, accessTokenID: accessTokenID})
          Cookies.set("selectedAccount", userDetails.accountNumber)
          setCurrentStep(3)
          setTokenExpireTime("00:00")
          handleTokenExpireTimer(token)
       } else {
         showTransferPopup(true)
       }
      } else if (!response?.responseData.responseData?.token && (response?.responseData.responseData?.wrongAttempt !== 5)) {
        setLoading(false);
        setInvalidCodeStatus(true)
      } else if (!response?.responseData.responseData?.token && (response?.responseData.responseData?.wrongAttempt == 5)) {
        setLoading(false);
        setInvalidCodeStatus(false)
        setLeftTime('00:00')
        setWrongAttempts(true) 
      } else {
        setLoading(false);
        setErrorMsg(renderDefaultMsg('400'))
      }
     }
    
     // resend otp
     const reSendEmailOTP = async (res) => {
      if (maxLimitReach) {
        setLeftTime('00:00')
        setOtpLimitExceed(true)
      } else {
        setOtpLimitExceed(false)
        handleOtpTimer()
        const data = {
              "otpType": "OTPQuickPay",
              "mediumType": "Email",
              "mobileNumber": "",
              "email": res.emailID,
              "accountNumber": res.accountNumber,
              "privateLabelUrl": Cookies.get("privateLabelUrl"),
              "ipAddress": Cookies.get("publicIp"),
              "browser": Cookies.get("browser"),
              "appSource": getAppSource(),
              "userType": getUserType(),
              "userName": ''
        }
                       
        const response = await resendCode(data)
        if (response?.lstResponseStatus[0].statusCode == 0) {

          const { lstResponseStatus } =  response
          const { otpCount, otp } = response
          if (lstResponseStatus[0].statusCode == 0) {
            setOtpLimitExceed(false)
            setInvalidCodeStatus(false)
            if ((otpCount == 5)) {
              setMaxLimitReach(true)
            }
          } else {
            setErrorMsg(lstResponseStatus[0].statusDesc)
          }
        } else {
          setErrorMsg(renderDefaultMsg('400'))
        }
      }
    }

  const handleDraftPaymentResponse = (details) => {
    scrollTop()
    // handleTokenExpireTimer(userDetails.token)
    stopTokenExpireTimer()
    setPaymentDetails(details)
    setCurrentStep(4)
    showFeedBackWidget()
  }

  const handleClose = () => { 
    setUserDetails({...userDetails, mlw: false})
  }

  const handleStep = () => {
    setCurrentStep(1)
  }

  const showFeedBackWidget = async () => {
    const result = await quickPayFeedbackDisplay(userDetails.accountNumber, "QuickPay");
    if (result) {
      if (result?.responseData?.lstResponseStatus[0].statusCode == 0) {
        props?.showFeedback(result?.responseData?.responseData?.headerText)
      }
    }
  }

  const handleEmailTooltipClose = () => {
    setEmailIdTooltip(false);
  };

  const handleEmailTooltipOpen = () => {
    setEmailIdTooltip(true);
  };
  
  const { borrowerSSN, foreignId, loanNumber, showPassword, captcha } = values;
  const disableBtn = loanNumber?.length >= 3 && (borrowerSSN.length >= 4 || foreignId.length >= 4) && loading === false;

  return (
    <CssBaseline>
      <Box container="true" maxWidth='xl' className={classes.mainRoot}>
       <Box className={classes.root}>

        <CustomBreadcrum backPage="Home" backPageLink="/" activePage="Make a payment" />
        <h1 className={classes.pageHeading} color="textPrimary" component='h4'>Quick Pay</h1>

        {(((currentStep == 1) || (currentStep == 2) || (currentStep == 3) || (currentStep == 4)) && !mediaQuery) && 
        <Box className="progress">
          <Box className={((currentStep == 1) || (currentStep == 2)) ? 'stepFirst step-1-active' : 'stepFirstDone step-1-done'}>Validation</Box>
          <Box className={((currentStep == 1) || (currentStep == 2)) ? 'stepSecond step-2-coming' : (currentStep == 3) ? 'stepSecondActive step-2-active' : 'stepSecondDone step-2-done'}>Payment & Bank Details</Box>
          <Box className={((currentStep == 1) || (currentStep == 2) || (currentStep == 3)) ? 'stepThird step-3-coming' : 'stepThirdActive step-3-active'}>Acknowledgement</Box>
        </Box>}

       {((currentStep == 1) || (currentStep == 2)) && <Box className={classes.formContainer}>
     
        <Box className={classes.alreadyRegistered}>
            *** {ALREADY_REGISTERED} <span onClick={() => history.push('/SignIn')} className={classes.link}>here</span>. ***
        </Box>

      {((currentStep == 1) || (currentStep == 2)) &&
      <> 
      <Box className={classes.benefitsContainer}>


          <Box style={{justifyContent: 'center', display: 'flex', paddingBottom: 14}}>
            <img src={benefits} className={classes.checkmark}/>   
            <Box style={{marginLeft: 10}}>           
              <Typography className={classes.onlinePaymentBenefits}>Benefits of Online Payments</Typography>
            </Box>  
          </Box>

          <Grid container >
            <Grid item md={4} sm={12} style={{justifyContent: 'center', display: 'flex', marginBottom: 10}}>
              <img src={symbols} className={classes.checkmark}/>              
                <Box style={{marginLeft: 10}}>
                  <Typography className={classes.benefitTitle}>Enhanced Data Privacy</Typography>
                </Box>
            </Grid>
            <Grid item md={5} sm={12} style={{justifyContent: 'center', display: 'flex', marginBottom: 10}}>
              <img src={lock} className={classes.checkmark}/>              
                <Box style={{marginLeft: 10}}>
                  <Typography className={classes.benefitTitle}>Security with end-to-end encryption</Typography>
                </Box>
              </Grid>
              <Grid item md={3} sm={12} style={{justifyContent: 'center', display: 'flex', marginBottom: 10}}>
                  <img src={camera} className={classes.checkmark}/>              
                  <Box style={{marginLeft: 10}}>
                    <Typography className={classes.benefitTitle}>24/7 Availability</Typography>
                  </Box>
              </Grid>
            </Grid> 
       </Box>

       <Box className={classes.line}></Box> 
       </>}
 
       {((currentStep == 1) || (currentStep == 2)) && <Grid container>
        <Grid item md={6} sm={12}>
         {(currentStep == 1) && <>
          <Typography className={classes.fieldsMandatory}>All fields are mandatory</Typography>
          <Box>
             <Box className={classes.inputContainer}>
              <TextField
                label={`${getLoanLabel()} Number`}
                variant="outlined"
                type="text"
                value={loanNumber}
                onChange={handleChange('loanNumber')}
                fullWidth
                inputProps={{
                  className: classes.inputStyle,
                  maxLength: 10
                }}
                InputLabelProps={{
                  classes: { root: classes.textField }
                }}
              />
                <FormGroup row style={{'justifyContent': 'start', 'height': '12px'}} >
                 <Box>
                  <Popover content={
                    <>
                      <div className={classes.tooltipTitle}>Save Loan Number  <a className={`${close} ${classes.close}`} onClick={hide}>
                          &times;
                        </a>
                      </div>
                      <div className={classes.desc}>We don't recommend saving your loan number if you're on shared device.</div>
                      </>
                    }
                    trigger="click"
                    open={open}
                    placement="bottom"
                    overlayStyle={{width: 300}}
                    onOpenChange={handleOpenChange}>
                   <FormControlLabel
                    control={<Checkbox
                      checked={checkboxState}
                      onClick={() => checkboxChangeHandler()}
                      name="Save Loan Number"
                    />}
                    className={classes.checkboxStyle}
                    classes={{
                      label: checkboxState ? classes.radioLabel : classes.radioLabel
                    }}
                  /> 
                  </Popover>
                  <span className={classes.saveLoanNumber}>Save Loan Number</span>
                  </Box>
                </FormGroup>
            </Box>

            <Box className={classes.radioBtn} style={{ marginTop: "-14px" }}>
                <RadioGroup row aria-label="account_type" name="account_type" value={radioValue} style={{ justifyContent: "flex-start" }}
                  onChange={handleRadioChange}>
                  <FormControlLabel value="true" checked={radioValue}
                    control={<Radio />} label="By SSN/EIN" />
                  {/* <FormControlLabel value=""
                      control={<Radio />} label="By Foreign ID" /> */}
                </RadioGroup>
            </Box>
            {radioValue ? <Box className={classes.inputContainer}>
              <FormControl variant="outlined" fullWidth>
                <InputLabel className={classes.labelStyle} htmlFor="outlined-adornment-ssn">{`Primary ${getBorrowerLabel()} SSN/EIN Last 4 Digits`}</InputLabel>
                <OutlinedInput
                  color="primary"
                  id="outlined-adornment-ssn"
                  type={showPassword ? 'text' : 'password'}
                  value={borrowerSSN}
                  onChange={handleChange('borrowerSSN')}
                  labelWidth={250}
                  inputProps={{
                    className: classes.inputStyle,
                    maxLength: 4
                    
                  }}
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  }
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleSubmit();
                    }
                  }}
                />
              </FormControl>
            </Box> :
              <Box className={classes.inputContainer}>
                <FormControl variant="outlined" fullWidth >
                  <InputLabel className={classes.labelStyle} htmlFor="outlined-adornment-foreignId">{`${getBorrowerLabel()} Foreign ID Last 4 Digits/Characters`}</InputLabel>
                  <OutlinedInput
                    color="primary"
                    id="outlined-adornment-foreignId"
                    type={showPassword ? 'text' : 'password'}
                    value={foreignId}
                    onChange={handleChange('foreignId')}
                    labelWidth={360}
                    inputProps={{
                      className: classes.inputStyle,
                      maxLength: 4
                    }}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    }
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleSubmit();
                      }
                    }}
                  />
                </FormControl>
              </Box>}
           
            <Box className={clsx(classes.inputContainer, classes.captchaContainer)}>
              <div>
                <Grid container row spacing={2}>
                  <Grid item xs={12} sm={12} md={6}>
                    <Grid container>
                      <Grid item xs={10} sm={10} md={10}>
                        <div className={classes.captchaarea}>
                          <div id="captcha" style={{margin: '0px 56px', paddingTop: '8px'}}>
                          </div>
                        </div>
                      </Grid>
                      <Grid item xs={2} sm={2} md={2} className={classes.buttonarea}>
                        {volumeIcon ? <VolumeOffIcon className={classes.volumeButton} /> : <VolumeUpIcon className={classes.volumeButton} onClick={() => { speakk({ text: captchaCode }); check() }} />}<br />
                        <RefreshIcon className={classes.refreshButton} onClick={() => { createCaptcha() }} />
                      </Grid>
                    </Grid>

                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <TextField
                      id="outlined-loan-input"
                      label="Answer"
                      color="primary"
                      autoComplete="off"
                      type="text"
                      value={captcha}
                      name="captcha"
                      variant="outlined"
                      fullWidth
                      onChange={handleChange('captcha')}
                      InputLabelProps={{
                        classes: { root: classes.textField }
                      }}
                      inputProps={{
                        className: classes.inputStyle
                      }}
                      onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleSubmit();
                        }
                      }}  
                    />
                    {captchaErr && <p className={classes.error}>Please enter correct Captcha.</p>}
                  </Grid>
                </Grid>
              </div>
            </Box>
           
           {(!errorMsg.includes('information') && !errorMsg.toLowerCase().includes('wrong private label client')) && !errorMsg.toLowerCase().includes('otp limit') && <Typography className={classes.errorMsg} dangerouslySetInnerHTML={{ __html: errorMsg !== '' ? errorMsg : '' }} />}
   
           {(errorMsg.includes('information') || errorMsg.toLowerCase().includes('wrong private label client')) && <>
            <Typography className={classes.validationMsg}> Your information doesn’t match our records. Please verify and try again.</Typography>
            </>}

           {/* {(!userDetails.emailID && !errorMsg && submitStatus) && <>
            <Typography className={classes.validationMsg}> We don’t have a registered email for this loan number. To make your payment, please use the <a href="./AccountVerification" target="_self" className={classes.contactUs}>SIGN UP & PAY</a> option.</Typography>
            <Typography className={classes.validationMsg}> For registering your contact details with us, you can contact our customer support team by <a href="./HelpLanding?contactus" target="_self" className={classes.contactUs}>clicking here.</a>.</Typography>
            <Typography className={classes.noteMsg}> <b>Note:</b> It will take up to 24 hours for the changes to be reflected in the system.</Typography>
            </>} */}

            {/* {(!userDetails.emailID && !errorMsg && submitStatus) && <>
            <Typography className={classes.validationMsg}> Registered email not found. Please create a <a href="./AccountVerification" target="_self" className={classes.contactUs}>MLW account</a> or <a href="./HelpLanding?contactus" target="_self" className={classes.contactUs}>contact us</a> to update your email. Changes will reflect within 24 hours.</Typography>
            </>} */}

            {/* {
              otpLimitExceed && <p className={classes.errorMsg}>You have exceeded the maximum limit to receive a temporary login code. Please try again after 30 minutes.</p>
            }  */}

            <Box className={classes.footerSection}>
                <Grid container style={{ marginTop: '12px' }}>
                    <Grid item xs={6} md={6} className={classes.pr35}>
                        <Box className={classes.cancelBtnBox}>
                        <Link to='/' style={{ textDecoration: "none" }}>
                        <Button
                            className={classes.cancelBtn}
                            variant="outlined"
                        >BACK</Button>
                        </Link>
                        </Box>
                    </Grid>
                    <Grid item xs={6} md={6} className={classes.pl35}>
                            <Button
                              disabled={(!disableBtn || !captcha)}
                              className={classes.saveBtn}
                              variant="contained"
                              onClick={() => handleSubmit()}
                              color="primary">
                              {loading ? <CircularProgress /> : "NEXT"}
                           </Button> 
                    </Grid>
                </Grid>
            </Box>

          </Box></>}
         
        {(currentStep == 2) && <Box >
                   {errorMsg !== '' && <p className={classes.errorMsg}>{errorMsg !== '' ? errorMsg : ''}</p>}
                   { (!otpLimitExceed && !invalidCode && !wrongAttempts) && <>
                       <Typography className={classes.emailSend}>An one-time passcode was sent to your registered email address at <b>{maskEmail(decrypt(userDetails.emailID))}</b></Typography>
                       <Typography className={classes.spam}>No login code received? Make sure to check Spam/Junk folder</Typography>
                      </>
                   }
                  <Box>
                   <Box className={classes.inputContainer}>
                     <TextField
                       color='primary'
                       id="outlined-email"
                       label="Temporary Login Code"
                       variant="outlined"
                       type="text"
                       labelWidth={250}
                       value={otp}
                       onChange={handleOtpChange('otp')}
                       fullWidth
                       inputProps={{
                         className: classes.inputStyle,
                         maxLength: 6,
                         form: {
                           autoComplete: 'off',
                         },
                       }}
                       InputLabelProps={{
                         classes: {
                           root: classes.labelStyle
                         }
                       }}
                     />
                      <Grid item md={12} xs={12} lg={12}>
                             <Grid container>
                                 <Grid item xs={5} md={6} className={classes.pr35}>
                                   { (leftTime == '00:00') && !invalidCode &&
                                   <Box textAlign="left"><p className={classes.linkStyle}>Didn’t receive code?</p></Box> }
                                   { invalidCode &&
                                   <Box textAlign="left"><p className={classes.invalidCode}>Invalid Login Code</p></Box> }
                                 </Grid>
                                 <Grid item xs={7} md={6} className={classes.pl35}>
                                   { (leftTime !== '00:00') ?
                                    
                                   <Box textAlign="right"><p className={classes.linkStyle}>Time Remaining <span className={classes.timer}>{showTimer(leftTime)}</span></p></Box> :
                                   <Box textAlign="right" onClick={(otpLimitExceed || wrongAttempts) ? '' : () => reSendEmailOTP(userDetails)}><p className={(otpLimitExceed || wrongAttempts) ? classes.disableResend :  classes.resendCode}>Resend Login Code</p></Box> 
                                   }
                                 </Grid>
                             </Grid>
                      </Grid>
                   </Box>
                   {
                     otpLimitExceed && <p className={classes.errorMsg}>You have exceeded the maximum limit to receive a temporary login code. Please try again after 30 minutes.</p>
                   }
                   {
                     wrongAttempts && <p className={classes.errorMsg}>
                     Too many failed temporary login code attempts. You may try again after 30 minutes.
                     </p>
                   }
                  

                <Box className={classes.footerSection}>
                      <Grid container style={{ marginTop: '12px' }}>
                          <Grid item xs={6} md={6} className={classes.pr35}>
                              <Box className={classes.cancelBtnBox}>
                              <Button
                                  className={classes.cancelBtn}
                                  variant="outlined"
                                  onClick={() => setCurrentStep(1)}
                              >BACK</Button>
                              </Box>
                          </Grid>
                          <Grid item xs={6} md={6} className={classes.pl35}>
                              <Box>
                                   
                                {loading ?
                                  <Button disabled={true} type='submit' className={classes.saveBtn} size="large" fullWidth variant="contained">
                                    <CircularProgress color='primary' />
                                  </Button>
                                  :
                                  <Button  className={classes.saveBtn} size="large" fullWidth variant="contained" color="primary" disabled={(otp?.trim()?.length !== 6) || otpLimitExceed || wrongAttempts} onClick={() => validateOtpCode()}>
                                    Submit
                                  </Button>
                                }
                              </Box>
                          </Grid>
                      </Grid>
                  </Box>
         
                 
                 </Box>
               </Box> }
              
          </Grid>
          <Grid item md={2} sm={0} className={classes.orSection}>
            { !mediaQuery && <>
            <Box className={classes.orLine}></Box> 
            <Typography className={classes.or}>OR</Typography>
            <Box className={classes.orLine}></Box></> }
          </Grid>
          <Grid item md={4} sm={12} style={{justifyContent: 'center'}}>

              <Box className={classes.body}>
                <Typography className={classes.mlw}>MyLoanWeb</Typography>

                <img className={classes.logo} src={macbook} alt='pc' />
               
                <Box className={classes.havingAccounts}> 
                  <Typography className={classes.benefits}>Benefits of having MyLoanWeb Account:</Typography>

                  <Box style={{paddingLeft: 10, alignContent: 'center', display: 'flex'}}>
                  <img src={checkmark} className={classes.checkmark}/>              
                  <Box style={{marginLeft: 10}}>
                    <Typography className={classes.benefitTitle}>Detailed Payment Transaction History</Typography>
                  </Box>
                  
                  </Box>
                  <Box style={{paddingLeft: 10, alignContent: 'center', display: 'flex'}}>
                  <img src={checkmark} className={classes.checkmark}/>              
                  <Box style={{marginLeft: 10}}>
                    <Typography className={classes.benefitTitle}>Transparent Loan Insights</Typography>
                  </Box>
                  </Box>

                  <Box style={{paddingLeft: 10, alignContent: 'center', display: 'flex'}}>
                  <img src={checkmark} className={classes.checkmark}/>              
                  <Box style={{marginLeft: 10}}>
                    <Typography className={classes.benefitTitle}>Easy Access to Documents</Typography>
                  </Box>
                  </Box>

                  <Box style={{paddingLeft: 10, alignContent: 'center', display: 'flex'}}>
                  <img src={checkmark} className={classes.checkmark}/>              
                  <Box style={{marginLeft: 10}}>
                    <Typography className={classes.benefitTitle}>Escrow management</Typography>
                  </Box>
                  </Box>

                </Box>

                  <Button className={classes.signUpBtn}
                              variant="contained"
                              onClick={() => history.push('/AccountVerification')}
                              >SIGN UP & PAY</Button> 

              </Box>

          </Grid>
         </Grid> }
        </Box> }

       {(currentStep == 3) && <Box className={classes.formContainer}>
            <Grid container>
              <Grid item sm={12} md={8}>               
                  <Typography className={classes.refreshPage}>*** Please do not refresh this page. ***</Typography>
              </Grid>

              <Grid item sm={12} md={4}>               
                <Box textAlign="right"><Typography className={classes.pageExpire}>This page expires in: <span className={classes.tokenTimer}>{showTokenExpireTimer(tokenExpireTime)} minutes</span></Typography></Box>
              </Grid>
             </Grid>
            <Box className={classes.line}></Box> 
            <Typography className={classes.welcome}>Welcome, {userDetails.pBorrowerName}!</Typography>
              <Grid container style={{paddingTop: '8px'}}>
                 <Grid item sm={12} md={2}> 
                    <Typography className={classes.account}>Loan Number</Typography>
                </Grid>

                <Grid item sm={12} md={4}>               
                   <Typography className={classes.loanNo}>{maskLoan(decrypt(userDetails.accountNumber))}</Typography>
                </Grid>

                <Grid item sm={12} md={2}>               
                  <Typography className={classes.account}>Property Address</Typography>
                </Grid>

                <Grid item sm={12} md={4}>               
                  <Typography className={classes.loanNo}>{userDetails.propertyAddress}</Typography>
                </Grid>
             </Grid>
             <Grid container style={{paddingTop: '8px'}}>
                 <Grid item sm={12} md={2}> 
                    <Typography className={classes.account}>Email Address</Typography>
                </Grid>
                <Grid item sm={12} md={4}> 
                  <Box className={classes.emailBox}>
                    <Typography className={classes.loanNo}>{maskEmail(decrypt(userDetails.emailID))}</Typography>
                    {!mediaQuery && <LightToolTip
                            arrow placement="bottom" title={PAYMENT_CONFIRMATION_EMAIL} >
                            <InfoIcon className={classes.emailInfo}/>
                          </LightToolTip> }
                      {mediaQuery && 
                      <ClickAwayListener onClickAway={handleEmailTooltipClose}>
                        <LightToolTip
                            arrow placement="bottom" title={PAYMENT_CONFIRMATION_EMAIL}
                            open={ emailTooltip }
                          >
                            <InfoIcon className={classes.emailInfo} onClick={handleEmailTooltipOpen}/>
                          </LightToolTip>
                      </ClickAwayListener>}
                     </Box> 
                </Grid>
              </Grid> 
              <Box className={classes.line}></Box> 
 
              <Payment handleStep={handleStep} handleDraftPaymentResponse={handleDraftPaymentResponse} userDetails={userDetails} purgedLoanInfo={purgedLoanInfo} purgedMsg={purgedMsg}/>
         </Box>        

        }

        {((currentStep == 4) && paymentDetails) &&
          <Box className={classes.autoPayContainer} ref={componentRef}>
          {!paymentDetails?.autoPay && !paymentDetails?.isBKChapter13 &&
          <Box className={classes.autoPayBg}>
            <Typography className={classes.dueDateOften}>Are you <b>forgetting</b> your <b>due date</b> often?</Typography>
            <Typography className={classes.dueDateStayStep}>Stay a step ahead in the game. Set up <b>AutoPay</b> now!</Typography>
            <Box className={classes.paymentAckFooterSection}>
                  <Button
                    className={classes.autopayBtn}
                    variant="contained"
                    onClick={() => setAccountRequired(true)}
                    >
                    SET Up Autopay
                  </Button>                    
              </Box>
          </Box> 
          }        

          <Box>
            <img src={congrats} className={classes.congratsBox} />
          </Box>

          <Box className={classes.paymentDetailsContainer}>
            <Typography className={classes.paymentSuccess}>Your payment has been scheduled successfully, and confirmation details have been sent to your registered email at <span className={classes.email}>{maskEmail(decrypt(userDetails?.emailID))}</span>.</Typography>

            <Typography className={classes.paymentAck}>Payment Acknowledgement Detail</Typography>

            <Box className={classes.popupCode}>
              <Typography className={classes.requestId}>Request ID #{decrypt(paymentDetails?.code)} </Typography>
            </Box>
             
             <Box style={{border: '2px solid #E7EDF0'}}>
              <Grid container>
                <Grid item md={3} sm={12}>
                  <h3 className={classes.itemText}>Loan Number</h3>
                  <h3 className={classes.itemSubText}>{maskLoan(decrypt(userDetails?.accountNumber))}</h3>
                </Grid>
                <Grid item md={3} sm={12}>
                  <h3 className={classes.itemText}>Amount</h3>
                  <h3 className={classes.itemSubText}>${paymentDetails?.totalPayment}</h3>
                  </Grid>
                <Grid item md={3} sm={12}>
                  <h3 className={classes.itemText}>Payment Date </h3>
                  <h3 className={classes.itemSubText}>{paymentDetails?.paymentDate}</h3>
                </Grid>
                <Grid item md={3} sm={12}>
                  <h3 className={classes.itemText}>Bank Account</h3>
                  <h3 className={classes.itemSubText}>{`${paymentDetails?.selectedBank?.nickName} ${maskAccountNo(decrypt(paymentDetails?.selectedBank?.bankAccountNumber))}`}</h3>
                </Grid>
              </Grid> 
            </Box>
            
            {!paymentDetails?.isBKChapter13 && <Typography className={classes.history}>To view your <a href="./SignIn" target="_blank" className={classes.historyLink}>transaction history</a>, login to MLW portal.</Typography>}
            <Typography className={!paymentDetails.isBKChapter13 ? classes.processedPayment : classes.processedPaymentBk}><b>Note:</b> Processed payments take 24 hours to reflect in transaction history.</Typography>

            <Grid container direction="row" alignItems="center" >
              <Grid item xs={8} sm={8} md={10}> 
              </Grid>
              <Grid item xs={4} sm={4} md={2}> 
                <ReactToPrint
                  trigger={() => <Box className={classes.printBtnIcon} >
                    Print
                  <PrintIcon className={classes.printIconStyle} />
                  </Box>}
                  content={() => componentRef.current}
                />
              </Grid>
            </Grid>

            <Box className={classes.paymentAckFooterSection}>
                <Button
                  className={classes.homePageBtn}
                  variant="contained"
                  onClick={() => setCurrentStep(1)}
                  color="primary">
                   Go to HomePage
                </Button>                    
            </Box>
          </Box>

        </Box> }

        { (currentStep == 0) &&
          <Box className={classes.autoPayContainer}>
            <Typography className={classes.session}>Session Timeout</Typography>
            <Box>
              <img src={sessionTimeOut} className={classes.congratsBox} />
            </Box>

            <Box className={classes.paymentDetailsContainer}>
              <Typography className={classes.sessionExpired}>{SESSION_EXPIRE}</Typography>
              <Box className={classes.paymentAckFooterSection}>
                  <Button
                    className={classes.homePageBtn}
                    variant="contained"
                    onClick={() => setCurrentStep(1)}
                    color="primary">
                     Go to HomePage
                  </Button>                    
              </Box>
            </Box>
          </Box> 
        }

        {/* {userDetails?.mlw && <AlreadyRegistered handleClose={handleClose}/>} */}
        {transferPopup &&
          <TransferAlert
            fromPrivateLabel={transferData.fromPrivateLabel}
            toPrivateLabel={transferData.toPrivateLabel}
            toPrivateLabelPhone={transferData.toPrivateLabelPhone}
            toPrivateLabelURL={transferData.toPrivateLabelURL}
          />}
        {accountRequiredPopup && <AccountRequired handleClose={() => setAccountRequired(false)}/>}

        </Box> 
      </Box>
    </CssBaseline>
  )
}
